/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cell-wrapper.vue?vue&type=template&id=1a5ceb30&"
import script from "./cell-wrapper.vue?vue&type=script&lang=ts&"
export * from "./cell-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./cell-wrapper.vue?vue&type=style&index=0&id=1a5ceb30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports